// Product hero / lifestyle images for the entire catalog
// Each product gets a curated lifestyle image that sells the *feeling* of the product.
// Images are from Unsplash/Pexels (free for commercial use).
// Use ?w=600&q=80 for card thumbnails, ?w=1200&q=80 for hero views.

const heroImages = {
  // ─── Productivity ───
  'soft-life-planner': {
    url: 'https://images.pexels.com/photos/7394374/pexels-photo-7394374.jpeg',
    focal: 'center',
    alt: 'Pink aesthetic planner flat lay',
  },

  // ─── Wedding ───
  'wedding-planner': {
    url: 'https://static.prod-images.emergentagent.com/jobs/6011386d-adfc-4415-9257-23eae86765a4/images/18d53882ccbb89752d55797df19124effb5a5c27aa3e3783998bbebb00432c13.jpeg',
    focal: 'center',
    alt: 'Elegant ivory wedding planner with gold foil and iPhone showing digital seating chart on romantic blush background',
  },
  'wedding-guest-book': {
    url: 'https://images.pexels.com/photos/34341295/pexels-photo-34341295.jpeg',
    focal: 'center',
    alt: 'Romantic wedding invitation with floral accents',
  },

  // ─── Baby ───
  'baby-milestone-book': {
    url: 'https://static.prod-images.emergentagent.com/jobs/6011386d-adfc-4415-9257-23eae86765a4/images/ce5133d3ae7abe4e7f96f96c4e8d896a931bf2ace61240e29c40e2d4e4674d98.jpeg',
    focal: 'center',
    alt: 'Charming baby milestone book on butter yellow to powder blue gradient with pastel stacking toy and booties',
  },
  'baby-sleep-tracker': {
    url: 'https://images.unsplash.com/photo-1559454403-b8fb88521f11?w=800&q=80',
    focal: 'center',
    alt: 'Soft teddy bear in cozy nursery setting',
  },
  'pregnancy-journal': {
    url: 'https://images.pexels.com/photos/19445910/pexels-photo-19445910.jpeg',
    focal: 'center 30%',
    alt: 'Expectant mother in lavender field',
  },

  // ─── Finance ───
  'budget-tracker': {
    url: 'https://static.prod-images.emergentagent.com/jobs/6011386d-adfc-4415-9257-23eae86765a4/images/46471281301963aff36b0e05a42dbb05b12ca6701851b1238d5a3a98c67af7ee.jpeg',
    focal: 'center',
    alt: 'Tablet showing colorful budget dashboard with pie charts on powder blue lavender background with succulent',
  },
  'savings-goal-tracker': {
    url: 'https://images.unsplash.com/photo-1707157284454-553ef0a4ed0d?w=800&q=80',
    focal: 'center',
    alt: 'Desk with financial charts and smartphone',
  },
  'debt-payoff-tracker': {
    url: 'https://images.unsplash.com/photo-1621606453029-5656bd7fa6c1?w=800&q=80',
    focal: 'center',
    alt: 'Clean minimalist desk with laptop and notebook',
  },

  // ─── Health & Fitness ───
  'fitness-journal': {
    url: 'https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=800&q=80',
    focal: 'center 20%',
    alt: 'Woman exercising in bright studio',
  },
  '12-week-workout': {
    url: 'https://static.prod-images.emergentagent.com/jobs/6011386d-adfc-4415-9257-23eae86765a4/images/6da9ad770d8366f8fb5b9ad5d5ced6b19fb2e6664d768f69aa1c4e07bc826fb3.jpeg',
    focal: 'center',
    alt: 'Bold 12-Week Workout program on dark tablet with fitness illustrations, kettlebell and coral resistance band',
  },
  'running-program': {
    url: 'https://images.pexels.com/photos/25906803/pexels-photo-25906803.jpeg',
    focal: 'center',
    alt: 'Runner on a sunlit path through golden landscape',
  },
  'self-care-journal': {
    url: 'https://static.prod-images.emergentagent.com/jobs/6011386d-adfc-4415-9257-23eae86765a4/images/f28baf33e07821898c84854a863042d830c82a1e5fa9163342d4fafa07fb2f0a.jpeg',
    focal: 'center',
    alt: 'iPad showing Self Care Journal with mood tracker on blush coral background, affirmation card and dried flowers',
  },

  // ─── Food ───
  'recipe-book': {
    url: 'https://static.prod-images.emergentagent.com/jobs/6011386d-adfc-4415-9257-23eae86765a4/images/b1f05453696443a5ec5ec30aee9d930e1543a11159643396482fa38d1363112a.jpeg',
    focal: 'center',
    alt: 'iPad showing recipe with food photography on sage green background, fresh basil, lemon, and weekly meal plan card',
  },
  'meal-planner': {
    url: 'https://images.pexels.com/photos/9050064/pexels-photo-9050064.jpeg',
    focal: 'center',
    alt: 'Fresh vegetables and fruits being prepared',
  },
  'high-protein-meal-plan': {
    url: 'https://images.pexels.com/photos/29479442/pexels-photo-29479442.jpeg',
    focal: 'center',
    alt: 'Colorful fresh vegetables ready for cooking',
  },

  // ─── Travel ───
  'travel-journal': {
    url: 'https://images.unsplash.com/photo-1672841828271-54340a6fbcd3?w=800&q=80',
    focal: 'center',
    alt: 'Beautiful beach with palm trees and ocean',
  },
  'ai-travel-planner': {
    url: 'https://static.prod-images.emergentagent.com/jobs/6011386d-adfc-4415-9257-23eae86765a4/images/7efa674b242dc393033ecef9a6f72bf20b00c45b3921df5d7ad46f331b850d9e.jpeg',
    focal: 'center',
    alt: 'iPad showing AI travel planner itinerary with ocean destination backdrop on aqua background, boarding pass and sunglasses',
  },

  // ─── Business ───
  'content-planner': {
    url: 'https://images.pexels.com/photos/4549411/pexels-photo-4549411.jpeg',
    focal: 'center',
    alt: 'Content creation workspace with camera and laptop',
  },
  'etsy-shop-planner': {
    url: 'https://images.pexels.com/photos/8927688/pexels-photo-8927688.jpeg',
    focal: 'center',
    alt: 'Organized business workspace',
  },
  'pinterest-strategy-guide': {
    url: 'https://images.pexels.com/photos/6067987/pexels-photo-6067987.jpeg',
    focal: 'center',
    alt: 'Creative phone content setup',
  },
  'digital-product-bundle': {
    url: 'https://static.prod-images.emergentagent.com/jobs/6011386d-adfc-4415-9257-23eae86765a4/images/c317492f29e0289b4020dd0f656b3c178b77ee9ea99a40b2b8451b763abe86da.jpeg',
    focal: 'center',
    alt: 'MacBook, iPad and iPhone showing colorful Lumera product collection on periwinkle background, modern digital bundle',
  },

  // ─── Study ───
  'study-planner': {
    url: 'https://images.pexels.com/photos/8199677/pexels-photo-8199677.jpeg',
    focal: 'center 25%',
    alt: 'Student with books in university library',
  },

  // ─── ADHD / Productivity ───
  'adhd-focus-planner': {
    url: 'https://images.unsplash.com/photo-1780479485424-0a47971bbc1b?w=800&q=80',
    focal: 'center',
    alt: 'Calm organized desk by sunny window',
  },

  // ─── Home ───
  'home-maintenance-log': {
    url: 'https://images.unsplash.com/photo-1600725935160-f67ee4f6084a?w=800&q=80',
    focal: 'center',
    alt: 'Organized home with boxes and tools',
  },
  'moving-checklist': {
    url: 'https://images.unsplash.com/photo-1714647211902-bb711d643a17?w=800&q=80',
    focal: 'center',
    alt: 'Woman organizing moving boxes in bright living room',
  },
  'family-weekly-organizer': {
    url: 'https://images.pexels.com/photos/30234378/pexels-photo-30234378.jpeg',
    focal: 'center',
    alt: 'Minimalist desk with laptop, notebook, and coffee',
  },

  // ─── Pets ───
  'puppy-journal': {
    url: 'https://images.pexels.com/photos/6246667/pexels-photo-6246667.jpeg',
    focal: 'center',
    alt: 'Golden retriever puppy on cozy blanket',
  },
  'pet-health-record': {
    url: 'https://images.pexels.com/photos/6235650/pexels-photo-6235650.jpeg',
    focal: 'center',
    alt: 'Veterinarian caring for pet',
  },

  // ─── Relationships ───
  'date-night-planner': {
    url: 'https://images.unsplash.com/photo-1548428938-b1063c60f386?w=800&q=80',
    focal: 'center',
    alt: 'Romantic evening with candles and sunset view',
  },

  // ─── Hobby ───
  'reading-journal': {
    url: 'https://images.pexels.com/photos/29827789/pexels-photo-29827789.jpeg',
    focal: 'center',
    alt: 'Cozy autumn reading with books and candles',
  },
  'garden-planner': {
    url: 'https://images.unsplash.com/photo-1559825378-ab2e990f09a4?w=800&q=80',
    focal: 'center',
    alt: 'Beautiful botanical garden flowers',
  },

  // ─── Seasonal ───
  'christmas-planner': {
    url: 'https://images.unsplash.com/photo-1607196804955-829a5a0a4292?w=800&q=80',
    focal: 'center',
    alt: 'Festive Christmas flat lay with cookies and decorations',
  },
};

/**
 * Get hero image data for a product slug.
 * Returns { url, focal, alt } or null if no hero image exists.
 * @param {string} slug 
 * @param {'thumb'|'hero'} size 
 */
export const getProductHeroImage = (slug, size = 'thumb') => {
  const img = heroImages[slug];
  if (!img) return null;

  let url = img.url;
  // Optimize Unsplash URLs with size params
  if (url.includes('unsplash.com') && !url.includes('&w=')) {
    url += (url.includes('?') ? '&' : '?') + (size === 'hero' ? 'w=1200&q=80' : 'w=600&q=80');
  }
  // Optimize Pexels URLs
  if (url.includes('pexels.com') && !url.includes('w=')) {
    url += (url.includes('?') ? '&' : '?') + (size === 'hero' ? 'w=1200' : 'w=600');
  }

  return { ...img, url };
};

/**
 * Get all product hero images (for preloading or catalog use)
 */
export const getAllHeroImages = () => heroImages;

export default heroImages;
